import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { COLOR, INDENTS } from 'vars/index'
import { Button } from '../Button'
import { ButtonColors, ButtonFonts } from '../Button.h'

export interface IInlinePrimaryLoginTemplateProps extends IButtonProps {
  title: string
  font?: ButtonFonts
  onClick?: IButtonProps['onClick']
}

export const InlinePrimaryLoginTemplate = ({
  title,
  font = ButtonFonts.Button2,
  onClick,
  ...rest
}: IInlinePrimaryLoginTemplateProps): JSX.Element => (
  <Button
    title={title}
    backgroundColorDefault={COLOR.TRANSPARENT}
    font={font}
    colorDefault={ButtonColors.COLOR_MAIN_DEFAULT}
    paddings={[INDENTS.INDENT_0]}
    onClick={onClick}
    {...rest}
  />
)
